import { useState } from 'react'

import { KuniriIcons, kuniriIconWeight } from '@/lib/icons'

interface UserAvatarProps {
  name: string
  src: string | null | undefined
  size?: 'md' | 'lg'
}

/**
 * Small public avatar used by the creator card and participant list. The name
 * is rendered next to it, so the image is decorative and the initials are an
 * accessible fallback rather than duplicate copy.
 */
export function UserAvatar({ name, src, size = 'md' }: UserAvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const failed = Boolean(src && failedSrc === src)

  const initial = name.trim().charAt(0).toLocaleUpperCase()
  const dimension = size === 'lg' ? 'size-16' : 'size-11'
  const iconSize = size === 'lg' ? 28 : 20
  const AvatarIcon = KuniriIcons.user

  return (
    <span
      className={`relative grid ${dimension} shrink-0 place-items-center overflow-hidden rounded-full bg-mint text-teal ring-1 ring-line`}
      aria-hidden="true"
    >
      {initial ? (
        <span className="font-display text-lg font-extrabold">{initial}</span>
      ) : (
        <AvatarIcon size={iconSize} weight={kuniriIconWeight} />
      )}
      {src && !failed ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          className="absolute inset-0 size-full object-cover"
          onError={() => setFailedSrc(src ?? null)}
        />
      ) : null}
    </span>
  )
}
